let trans = {};
let data = require(`./data/global.json`);
trans = { ...data, ...trans };
export default trans;
